import LeadEventHistory from 'components/lead-event-history'

const History = ({ leadId, lead }) => (
  <LeadEventHistory params={{ leadId }} lead={lead} />
)

export default History
